// extracted by mini-css-extract-plugin
export default {"cta":"VG-z","disabled":"WG-z"};